export default "__VITE_ASSET__DVx5MvQn__"